import { Center, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import { FaCheck } from '@react-icons/all-files/fa/FaCheck';

import { MarketplaceVehicle, formatVehicleSummary } from '../../../../../utils/cars';
import { formatMoney } from '../../../../../utils/helpers';
import MarketplaceCard from '../MarketplaceCard';

type MarketplaceAcceptedProps = {
  amount?: number | null;
  dealershipName?: string | null;
  vehicle: MarketplaceVehicle;
};

const MarketplaceAccepted = ({ amount, dealershipName, vehicle }: MarketplaceAcceptedProps) => (
  <MarketplaceCard height="100%" alignItems="center" justifyContent="center">
    <Flex direction="column" align="center" textAlign="center">
      <Center
        w="56px"
        h="56px"
        borderRadius="full"
        bg="offerTopBadgeBg"
        color="greenDark"
        mb="16px"
      >
        <Icon as={FaCheck} boxSize="22px" />
      </Center>

      <Heading
        as="h2"
        fontFamily="heading"
        fontSize="22px"
        fontWeight="700"
        color="leaseEndBlue"
        letterSpacing="-0.01em"
      >
        Offer accepted
      </Heading>

      <Heading
        as="span"
        display="block"
        fontFamily="heading"
        fontSize={{ base: '38px', md: '44px' }}
        fontWeight="700"
        color="leaseEndBlue"
        letterSpacing="-0.025em"
        lineHeight="1"
        mt="8px"
      >
        {formatMoney(amount)}
      </Heading>

      <Text fontSize="13.5px" color="gray.600" lineHeight="1.55" maxW="48ch" mt="18px">
        {dealershipName != null && dealershipName !== '' ? (
          <>
            Your sale is in progress with{' '}
            <Text as="strong" color="leaseEndBlue" fontWeight="700">
              {dealershipName}
            </Text>
            . We're handling the details. If we need anything from you, we'll reach out.
          </>
        ) : (
          "Your sale is in progress. We're handling the details. If we need anything from you, we'll reach out."
        )}
      </Text>

      <Flex
        direction="column"
        gap="4px"
        mt="24px"
        px="18px"
        py="14px"
        minW="260px"
        bg="grayLightBackground"
        borderWidth="1px"
        borderColor="grayMediumBackground"
        borderRadius="10px"
      >
        <Text
          fontSize="10px"
          fontWeight="700"
          letterSpacing="0.16em"
          textTransform="uppercase"
          color="grayMedium"
        >
          Your vehicle
        </Text>
        <Text fontFamily="heading" fontSize="15px" fontWeight="700" color="leaseEndBlue">
          {formatVehicleSummary(vehicle)}
        </Text>
      </Flex>
    </Flex>
  </MarketplaceCard>
);

export default MarketplaceAccepted;
